import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const FineTuningBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
`
